import logger from '@/providers/Logging';
import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}/responses']['PUT'];
type Input = ThisApi['params'];
type Body = ThisApi['body'];

const updateQuestionnaireResponses = async ({ questionnaireId }: Input, body: Body): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaires/{questionnaireId}/responses', { questionnaireId });
  const response = await formsBackendClient.put(path, body);
  logger.info('updateQuestionnaireResponses response headers', response.headers);
  return response.data;
};

export default updateQuestionnaireResponses;
